import React, { useContext, useState } from "react";
import { Form } from 'react-bootstrap';
import { controlClass } from '../../../utility/ui-util';
import ControlLabel from "../ControlLabel/ControlLabel";
import StateContext from '../../../contexts/state-context';
import ReactMarkdown from 'react-markdown';
import ReactSelect from 'react-select';

const LOV = (props) => {
    const options = props.variable.values.map((e, key) => { return { "value": e.value, "label": e.label }; });
    const { setPropertyValue } = useContext(StateContext);

    const validateValue = (value) => {
        const allErrors = {};
        let v = value;

        if (options !== undefined && options.length > 0) {
            if (!options.find(o => o.value === v)) {
                allErrors.invalid = "Value must be one of the predefined options.";
            }
        }
        else {
            if (props.min > 0) {
                if (initialType === "number") {
                    if (parseFloat(v) < props.min) {
                        allErrors.invalid = "Value must be greater than " + props.min + ".";
                    }
                } else {
                    if (String(v).length < props.min) {
                        allErrors.invalid =
                            "Length is shorter than the minimum length " + props.min + ".";
                    }
                }
            }

            if (Object.keys(allErrors).length === 0 && props.max > 0) {
                if (initialType === "number") {
                    if (parseFloat(v) > props.max) {
                        allErrors.invalid = "Value must be less than " + props.max + ".";
                    }
                } else {
                    if (String(v).length > props.max) {
                        allErrors.invalid =
                            "Length is longer than the maximum length " + props.max + ".";
                    }
                }
            }

            if (Object.keys(allErrors).length === 0 && props.regexp) {
                if (!String(v).match(props.regexp)) {
                    allErrors.invalid = props.invalidPatternText;
                }
            }
        }


        return allErrors;
    };

    const handleChange = (newValue) => {
        const allErrors = validateValue(newValue.value);
        setErrors(allErrors);

        if (Object.keys(allErrors).length > 0) {
            setValidated(false);
        } else {
            setValidated(true);
        }

        setPropertyValue(
            props.group,
            props.advanced,
            props.variableName,
            newValue.value,
            props.hostIndex
        );
    };


    const [errors, setErrors] = useState(
        props.variable.currentValue !== "" ? validateValue(props.variable.currentValue) : {}
    );

    const [validated, setValidated] = useState(false);

    return (
        <Form.Group>
            <ControlLabel isOptional={props.variable.isOptional} isObsolete={!!props.variable.isObsolete} text={props.variable.label} />
            <StateContext.Consumer>
                {({ setPropertyValue }) =>
                    <ReactSelect
                        isClearable={false}
                        classNames={{
                            control: (state) => controlClass(props.variable, props.variable.currentValue)
                        }}
                        onChange={(item) => { handleChange(item) }}
                        disabled={!!props.disabled}
                        options={options}
                        isInvalid={!!errors.invalid}
                        value={{ value: props.variable.currentValue, label: options.find(o => o.value === props.variable.currentValue) ? options.find(o => o.value === props.variable.currentValue).label : props.variable.currentValue }} />
                }
            </StateContext.Consumer>
            {errors.invalid && (
                <div className="form-text text-danger small">
                    {errors.invalid}
                </div>
            )}
            <Form.Text className="text-muted">
                <ReactMarkdown
                    skipHtml={true}>
                    {props.variable.description}
                </ReactMarkdown>
            </Form.Text>
        </Form.Group>
    )
};

export default LOV;
